// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import 'mint-ui/lib/style.css'
import 'swiper/dist/css/swiper.css'
import './assets/sass/common.scss'
import App from './App'
import router from './router'
import myComponents from './utils' /* 按需引入UI组件及全局方法 */
import verify from './utils/verify'
// import axios from './utils/axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import VueClipboard from 'vue-clipboard2'
import { Popup, Cell, Switch, CellGroup, SwitchCell, Search } from 'vant'

if (/(iphone|ipad|ipod|ios)/i.test(navigator.userAgent.toLowerCase())) {
  // 处理iOS
  if (!sessionStorage.getItem('initLink')) {
    sessionStorage.setItem('initLink', document.URL)
  }
}
Vue.use(Popup)
Vue.use(Cell)
Vue.use(Switch)
Vue.use(CellGroup)
Vue.use(SwitchCell)
Vue.use(Search)
Vue.use(VueClipboard)
Vue.use(VueAwesomeSwiper)
Vue.use(myComponents)

Vue.config.productionTip = false

Vue.prototype.verify = verify

Vue.prototype.wxShare = function (title, desc, imgUrl, link) {
  if (link !== undefined && link !== '') {
    link = link.replace(':18080', '')
  } else {
    link = window.location.href
    // console.log('link', link)
    // alert("link============>"+link)
    link = link.replace(':18080', '')
    // alert("link============>replace"+link)
    // console.log('2', '')
    // alert(2)
    // console.log('link', link)
  }
  let url = window.location.href
  if (/(iphone|ipad|ipod|ios)/i.test(navigator.userAgent.toLowerCase())) {
    // 处理iOS
    if (sessionStorage.getItem('initLink')) {
      url = sessionStorage.getItem('initLink')
    }
  }
  this.$axios.post('/pub/auth/wx-js-config', {
    url: encodeURIComponent(url)
  }).then(res => { // 获得签名配置
    const list = res.data
    wx.config({

      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: list.appId, // 必填，公众号的唯一标识
      timestamp: list.timestamp, // 必填，生成签名的时间戳
      nonceStr: list.nonceStr, // 必填，生成签名的随机串
      signature: list.signature, // 必填，签名，见附录1
      jsApiList: [
        'chooseImage', 'uploadImage', 'downloadImage', 'getLocalImgData',
        'chooseWXPay', 'scanQRCode',
        'onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems',
        'updateTimelineShareData', 'updateAppMessageShareData'

      ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    })
  })
  wx.ready(() => {
    // console.log('========', link)
    // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，
    // 则可以直接调用，不需要放在ready函数中。
    wx.onMenuShareAppMessage({ // 分享给朋友
      title: title, // 分享标题
      desc: desc, // 分享描述
      link: link, // 分享链接 默认以当前链接
      imgUrl: imgUrl, // 分享图标
      // 用户确认分享后执行的回调函数
      success: function () {

      },
      // 用户取消分享后执行的回调函数
      cancel: function () {

      }
    })
    // 分享到朋友圈
    wx.onMenuShareTimeline({
      title: title, // 分享标题
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      // 用户确认分享后执行的回调函数
      success: function () {},
      // 用户取消分享后执行的回调函数
      cancel: function () {

      }
    })
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js